var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('el-carousel',{staticClass:"carousel",staticStyle:{"height":"31.08vw","overflow-y":"hidden"}},_vm._l((_vm.imageList),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{staticClass:"image",style:({
          background: 'url(' + item.url + ')   center top no-repeat',
        })})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }